"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isSameValue(value, _ref) {
  var valueToCompare = _ref.valueToCompare,
    _ref$typeStrict = _ref.typeStrict,
    typeStrict = _ref$typeStrict === void 0 ? true : _ref$typeStrict;
  var areStrings = typeof value === 'string' && typeof valueToCompare === 'string';
  if ((!value || !valueToCompare) && !areStrings) {
    return new classes_1.ValidationResult(false);
  }
  var mismatchError = 'Os valores não são iguais';
  if (!!typeStrict) {
    if (value === valueToCompare) {
      return new classes_1.ValidationResult(true);
    } else {
      return new classes_1.ValidationResult(false, mismatchError);
    }
  } else {
    if (value == valueToCompare) {
      return new classes_1.ValidationResult(true);
    } else {
      return new classes_1.ValidationResult(false, mismatchError);
    }
  }
}
exports.default = new classes_1.Validator(isSameValue);